module.exports = __webpack_public_path__ + "static/media/ssidemoday.b53f8146.jpeg";